// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
  production: false,
  baseUrl: '',
  appInsights: {
    instrumentationKey : '3707a383-ba6b-4550-8b15-76884a06e94a'
  },
  defaultCountryId: 1,
  esignatureBaseURL:"https://preprodonlinerental-qa.azurewebsites.net/sign",
  ClientLogo: '',
  consentScopes: [''],
  EncryptionKey: "ES0FT678LDPSC456",
  frenchLogo: 'https://www.psconline2.selfstoragemanager.com/Online/Images/PSCImages/PSC-Logo-French-Website.png',
  englishLogo: 'https://www.psconline2.selfstoragemanager.com/Online/Images/PSCImages/PSC-Logo-English-Website.png',
  termsAndConditionURL: '',
  ldpaReturnURL:'',
  tollfreeNumber: '1 (877) 777-8672',
  entityName: 'Public Storage Canada',
  userId:'-8',
  tdThreeDSEnabled: true,
  postLogoutRedirectUri: '',
  authority: '',
  protectedResourceMap: '',
  clientID: '',
  redirectUri: '',
  syncfusionKey: '',
  angularAppinsigthsKey: '',
  enableAppInsightTracking: true,
  showReservation: true,
  hCaptchaSiteKey: ''
};
